module.exports = __webpack_public_path__ + "img/pile-drilling-rig.689bdd7.png";